import type { ReactNode } from "react";

interface ProfileContactItem {
  href: string;
  icon: ReactNode;
  iconClassName: string;
  title: string;
}

interface ProfileContactGridProps {
  items: ProfileContactItem[];
}

export const ProfileContactGrid = ({ items }: ProfileContactGridProps) => {
  return (
    <section className="mt-7">
      <h2 className="px-0.5 text-[14px] font-bold uppercase tracking-[0.18em] text-[#9DA1A5]">
        Каналы связи TISIT
      </h2>
      <div className="mt-4 grid grid-cols-2 gap-3">
        {items.map((item) => (
          <a
            key={item.title}
            href={item.href}
            target={item.href.startsWith("http") ? "_blank" : undefined}
            rel={item.href.startsWith("http") ? "noreferrer" : undefined}
            className="flex min-h-[62px] items-center gap-3 rounded-[16px] bg-white/70 px-4 text-[#565A5E] shadow-[0_14px_28px_rgba(22,24,28,0.024),inset_0_0_0_1px_rgba(238,240,237,0.68),inset_0_1px_0_rgba(255,255,255,0.9)] transition-[background-color,transform] [transition-duration:220ms] [transition-timing-function:cubic-bezier(0.32,0.72,0,1)] active:scale-[0.985]"
          >
            <span
              className={`flex size-10 shrink-0 items-center justify-center rounded-full ${item.iconClassName}`}
            >
              {item.icon}
            </span>
            <span className="min-w-0 truncate text-[15px] font-semibold leading-none">
              {item.title}
            </span>
          </a>
        ))}
      </div>
    </section>
  );
};
